module.exports = __webpack_public_path__ + "img/wangshangbanshi.404490b1.png";